import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {TaskRecord, TaskRecordService} from "../../../../../lib/task/task-record.service";
import {Set} from "immutable";
import {Observable} from "rxjs";
import {QueryResult} from "../../../../../lib/util/services";
import {ToasterService} from "../../../../../fork/angular2-toaster/src/toaster.service";
import {TranslateService} from "@ngx-translate/core";
import {UiConstants} from "../../../../../util/core-utils";

@Component({
  selector: 'app-task-record-process-navigation-dialog',
  templateUrl: './task-record-process-navigation-dialog.component.html',
  styleUrls: ['./task-record-process-navigation-dialog.component.scss']
})
export class TaskRecordProcessNavigationDialogComponent implements OnInit {

  taskRecords: TaskRecord.TaskRecord[] = [];

  constructor(
    public dialogRef: MatDialogRef<TaskRecordProcessNavigationDialogComponent, TaskRecordProcessNavigationDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: TaskRecordProcessNavigationDialogData
  ) {
  }

  ngOnInit(): void {
      this.taskRecords = this.data.taskRecords!;
      return;
  }

  public static openDialog(
    dialog: MatDialog,
    data: TaskRecordProcessNavigationDialogData,
    resultCallback: (result?: TaskRecordProcessNavigationDialogResult) => void) {
    const dialogRef = dialog.open(TaskRecordProcessNavigationDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto'
    });
    dialogRef.afterClosed().subscribe((result: TaskRecordProcessNavigationDialogResult) => {
      resultCallback(result);
    });
  }

  onTaskRecordSelected(taskRecord: TaskRecord.TaskRecord) {
    this.closeDialog(taskRecord);
  }

  getHeaderDictionaryKey() {
    return this.data.navigationType === NavigationType.NEXT ? 'TASK_RECORD_JUMP_TO_NEXT' : 'TASK_RECORD_JUMP_TO_PREV';
  }

  closeDialog(taskRecord?: TaskRecord.TaskRecord) {
    this.dialogRef.close({navigateTo: taskRecord});
  }

}

export interface TaskRecordProcessNavigationDialogData {
  currentTaskRecordId: number;
  navigationType: NavigationType;
  taskRecords: TaskRecord.TaskRecord[];
}

export interface TaskRecordProcessNavigationDialogResult {
  navigateTo?: TaskRecord.TaskRecord;
}

export enum NavigationType {
  NEXT, PREV
}
